import AdminExploreFilters, { AdminExploreFilterLocationType } from '../types/AdminExploreFilters';
import ExploreServiceFilters from '../types/ExploreServiceFilters';

const getAdminExploreServiceFilters = (adminFilters: AdminExploreFilters) => {
  const filters: ExploreServiceFilters = {};
  if (adminFilters.isClosed !== undefined) {
    filters.isClosed = adminFilters.isClosed;
  }
  const locationTypes: AdminExploreFilterLocationType[] = ['area', 'city', 'country', 'state'];
  locationTypes.forEach(locationType => {
    if (adminFilters[locationType]?.length) {
      filters.placeIds = [
        ...(filters.placeIds ?? []),
        {
          ids: adminFilters[locationType].map(({ id }) => id),
          placeType: locationType
        }
      ];
    }
  });

  return filters;
};

export default getAdminExploreServiceFilters;
